var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreadmill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m196.39 138.054c-9.075 6.243-11.52 18.877-5.156 27.889l29.169 41.318c5.775 7.922 9.369 7.922 18.739 7.951h31.143l16.912-26.298-17-15.255-23.482.118c-1.237 0-1.385 0-2.121-1.06l-20.3-29.508c-6.249-9.071-18.8-11.398-27.904-5.155z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m423.64 341.522-22.068 17.405 5.156 26.505-.354.883c-3.182 8.305-1.62 42.054 15.645 42.054l5.127 7.421 4.891-7.421 21.773-58.605c2.976-8.04 6.511-14.784-1.915-17.876z",
    fill: "#fd8087",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m358.673 256.56c-32.115 7.156-63.582 27.506-55.45 58.664l16.352 33.867c2.269 4.653 4.861 8.04 11.874 10.455l75.279 25.886 16.912-43.909-46.081-15.373c-5.745-1.914-6.158-3.858-7.307-9.836l-3.064-15.814z",
    fill: "#d6dcea",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m358.673 256.56c-26.812-17.434-55.509-22.234-88.301 0l-35.474 34.662c-5.745 5.625-9.841 13.046-9.841 22.765v13.635 59.253l22.392 16.58 22.775-16.58-.177-40.611c0-11.662-1.856-11.456 8.043-16.992l25.132-14.047c14.321-8.218 50.325-23.915 55.451-58.665z",
    fill: "#f8f2f0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m270.195 173.659.059 24.237.029 17.316.088 41.347h88.301l10.459-52.715c-23.482-4.977 13.17-32.895-7.042-44.734l-19.004-27.359-24.926-13.694-21.449 14.047z",
    fill: "#fd8087",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m225.057 386.874c-10.577 0-37.772 12.516-36.623 41.494l36.917 18.2 44.961-18.2-.088-40.788v-.707h-45.167z",
    fill: "#fd8087",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m276.382 43.08c-9.075 9.983-14.643 23.236-14.643 37.754 0 22.853 15.792 42.525 34.973 51.272 6.806 3.092 14.054 4.8 21.155 4.8 9.782 0 18.149-1.826 25.221-5.154 12.492-5.831 21.007-16.227 26.458-29.067 0 0-10.076-57.191-41.838-59.606-14.379-1.089-38.48 8.57-51.326.001z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m267.013 4c-9.811 18.111-3.241 30.716 9.369 39.08 12.846 8.57 31.997 12.722 46.375 13.812 31.761 2.415 46.788 45.794 46.788 45.794 13.7-41.436 4.302-74.331-28.845-86.052-19.18-6.803-39.598 4.329-73.687-12.634z",
    fill: "#609ecf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m280.625 304.945-25.103 14.018c-9.929 5.566-8.073 5.33-8.043 16.992l.177 50.918h22.569l-.177-40.611c0-11.662-1.856-11.456 8.043-16.992l25.132-14.047c14.319-8.216 50.323-23.913 55.45-58.664h-33.794c-9.87 27.654-31.408 41.024-44.254 48.386z",
    fill: "#d6dcea",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m48.867 178.813v190.921l21.42 22.5 21.39-22.5v-166.625l-21.39-25.327z",
    fill: "#609ecf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m32.132 128.012c-9.811-5.566-22.834-2.356-28.962 7.127-6.128 9.512-3.094 21.822 6.718 27.388l28.697 16.286 42.781 24.296 36.181 20.526c9.811 5.566 22.834 2.356 28.933-7.156 6.128-9.483 3.094-21.822-6.718-27.388z",
    fill: "#f8f2f0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m48.867 184.673v28.036l13.583 8.069c10.076 5.713 7.277 4.417 7.837 14.047v134.908h21.39v-160.764l-10.312-5.86z",
    fill: "#1c74bb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m122.319 179.196c9.811 5.566 12.846 17.876 6.718 27.388-6.099 9.483-19.122 12.693-28.933 7.156l17.442 9.895c9.811 5.566 22.834 2.356 28.933-7.156 6.128-9.483 3.094-21.822-6.718-27.388z",
    fill: "#d6dcea",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m350.247 314.958 8.456 20.261c1.179 5.978 5.804 7.922 11.55 9.836l46.11 15.373 7.277-18.907-46.081-15.373c-5.745-1.914-6.158-3.858-7.307-9.836l-3.064-15.814-8.515-43.939c-1.237 8.423-4.302 15.756-8.426 22.087-12.875 19.849-36.181 30.362-47.023 36.576l6.924 14.342c10.842-4.889 15.645-6.715 28.078-15.225 7.69-5.3 10.017-9.747 12.021.619z",
    fill: "#92bcde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m328.473 214.064c0 9.866-.56 19.496-1.62 28.831-.53 4.624-1.208 9.188-1.974 13.665h8.662 25.132l10.459-52.715c-1.709-.353-3.123-.854-4.243-1.443l-14.466-4.948c-10.459-3.563-16.087-15.019-12.522-25.444 3.418-10.042 14.083-15.608 24.189-12.899l-19.004-27.359c-7.071 3.328-15.439 5.154-25.221 5.154-.648 0-1.296 0-1.945-.029 7.957 22.44 12.553 48.856 12.553 77.187z",
    fill: "#fe636e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m140.704 428.368-30.878 39.816 30.878 39.816h331.462c21.891 0 39.834-17.905 39.834-39.816 0-21.881-17.943-39.816-39.834-39.816-82.379 0-164.729 0-247.079 0-28.138 0-56.245 0-84.383 0z",
    fill: "#609ecf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m140.704 491.179v16.821h331.462c21.891 0 39.834-17.905 39.834-39.816 0-9.129-3.123-17.581-8.368-24.296 3.948 22.234-2.858 47.291-39.157 47.291z",
    fill: "#1c74bb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m473.079 475.914h-332.375c-4.268 0-7.726-3.46-7.726-7.73s3.459-7.73 7.726-7.73h332.375c4.268 0 7.726 3.46 7.726 7.73s-3.458 7.73-7.726 7.73z",
    fill: "#d6dcea"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m48.867 369.734h-34.383c-5.451 0-9.929 4.476-9.929 9.925v118.417c0 5.478 4.478 9.925 9.929 9.925h126.221v-39.816-39.816-10.955c0-26.21-21.479-47.679-47.701-47.679h-1.326-42.811z",
    fill: "#f8f2f0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m91.677 369.734h-30.553c8.839 0 17.118 2.444 24.219 6.656 2.239 1.325 4.361 2.827 6.335 4.476 10.459 8.776 17.148 21.91 17.148 36.547v90.587h31.879c0-30.186 0-60.372 0-90.587 0-26.21-21.479-47.679-47.701-47.679z",
    fill: "#d6dcea",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m247.656 387.581.029 15.696.059 25.091h22.569l-.088-40.787v-.707h-22.569z",
    fill: "#fe636e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m423.64 341.522-7.277 18.907-.118.265 36.269 12.487 1.296-3.416c2.976-8.04 6.511-14.784-1.915-17.876z",
    fill: "#fe636e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m339.994 62.693c1.797 31.658-6.865 52.715-28.049 73.83 1.326.177 2.652.295 3.978.353.648.029 1.296.029 1.945.029 9.782 0 18.149-1.826 25.221-5.154 12.492-5.831 21.007-16.227 26.458-29.067-.002.002-9.548-27.622-29.553-39.991z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m305.197 15.132c15.94 5.625 26.399 16.197 31.437 30.215 1.886 5.301 3.005 11.102 3.359 17.346 20.006 12.369 29.552 39.993 29.552 39.993 13.7-41.436 4.302-74.331-28.845-86.052-12.227-4.329-24.926-1.384-41.396-3.063 2.004.354 3.949.884 5.893 1.561z",
    fill: "#1c74bb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m350.424 197.454c-10.459-3.563-16.087-15.019-12.522-25.444 3.418-10.042 14.083-15.608 24.189-12.899.412.088.854.236 1.267.383l52.739 17.964c7.808 2.68 13.258 9.983 13.583 18.2v18.229 34.162c0 11.073-9.34 20.026-20.33 19.967-11.049-.029-19.858-9.1-19.858-20.144v-33.572c0-2.003.501-3.357-1.237-3.946l-19.122-6.508z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m191.234 165.943 29.169 41.318c5.775 7.922 9.369 7.922 18.739 7.951h31.143l-.029-16.492h-20.831c-9.369 0-12.964-.029-18.709-7.951l-29.169-41.318c-2.652-3.74-3.771-8.099-3.536-12.398-.56.324-1.09.648-1.62 1.001-9.076 6.244-11.521 18.878-5.157 27.889z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m337.902 172.01c-3.565 10.425 2.062 21.881 12.522 25.444l14.466 4.948 4.243 1.443 19.122 6.508c1.738.589 1.237 1.944 1.237 3.946v33.572c0 11.044 8.809 20.114 19.858 20.144 8.043.029 15.203-4.771 18.473-11.691-1.031.177-2.062.236-3.123.236-11.049-.029-19.858-9.1-19.858-20.114v-33.602c0-1.973.53-3.328-1.208-3.917l-19.122-6.538-18.739-6.391c-.648-.206-1.267-.471-1.886-.736-9.222-4.211-13.966-14.901-10.636-24.708.236-.677.471-1.296.766-1.914-7.217 1.06-13.611 6.007-16.115 13.37z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m71.421 466.108h-15.763c-4.268 0-7.726-3.46-7.726-7.73s3.459-7.73 7.726-7.73h15.763c4.268 0 7.726 3.46 7.726 7.73s-3.458 7.73-7.726 7.73z",
    fill: "#609ecf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m71.436 429.59h-15.792c-4.268 0-7.726-3.46-7.726-7.73s3.459-7.73 7.726-7.73h15.792c4.268 0 7.726 3.46 7.726 7.73s-3.459 7.73-7.726 7.73z",
    fill: "#609ecf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreadmill);
export default __webpack_public_path__ + "static/media/treadmill.d57e82eef0d8e9ccecf3bfe872ce8303.svg";
export { ForwardRef as ReactComponent };